import client from './client';

export default {
  completeProfileApi: (data) => client.put('/save-profile', data).then((res) => res.data)
};
